import { Component, Input, OnInit } from '@angular/core';
import { Client } from '@app/core/models/client';
import { JourneySelectService } from '@app/core/services/journey-select.service';
import { OnboardingToggleComponent } from '../../../onboarding-toggle/onboarding-toggle.component';
import { FormsModule } from '@angular/forms';
import { AgentJourneySelectComponent } from './agent-journey-select/agent-journey-select.component';
import { AgentExpressConsentComponent } from './agent-express-consent/agent-express-consent.component';
import { AgentValidationComponent } from './agent-validation/agent-validation.component';
import { QuickLaunchContentComponent } from '../../../../shared/quick-launch-content/quick-launch-content.component';

@Component({
    selector: 'app-agent-onboarding-config',
    templateUrl: './agent-onboarding-config.component.html',
    styleUrls: ['./agent-onboarding-config.component.scss'],
    standalone: true,
    imports: [OnboardingToggleComponent, FormsModule, AgentJourneySelectComponent, AgentExpressConsentComponent, AgentValidationComponent, QuickLaunchContentComponent]
})
export class AgentOnboardingConfigComponent implements OnInit {
  @Input() client: Client;
  preview = false;
  showConfigGroup: boolean = false;

  constructor(private journeySelectService: JourneySelectService) {
  }

  ngOnInit() {
    this.setEnabledIfJourneySelect();
  }

  private setEnabledIfJourneySelect(): void {
    if (this.client.onboarding.csr.enabled !== 'true' && this.journeySelectService.init) {
      this.client.onboarding.csr.enabled = 'true';
    }
  }

}
